import { render, staticRenderFns } from "./ManifestView.vue?vue&type=template&id=386cc2e0&"
import script from "./ManifestView.vue?vue&type=script&lang=js&"
export * from "./ManifestView.vue?vue&type=script&lang=js&"
import style0 from "./ManifestView.vue?vue&type=style&index=0&id=386cc2e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports